<div class="relative" [formGroup]="dateRangeForm">
  <!-- Date Range Input -->
  <label
    #dateRangeTrigger
    (click)="toggleDropdown()"
    class="select flex items-center w-full border border-neutral-300 rounded-md shadow-xs text-base px-md h-[2.75rem] cursor-pointer"
    [class.text-neutral-400]="!appliedStartDate() && !appliedEndDate()"
    [class.text-neutral-900]="appliedStartDate() || appliedEndDate()">
    <span class="flex-1 text-sm">{{ getDisplayText() }}</span>

    <lib-chevron-down-icon
      [iconClass]="
        'size-5 transition-transform duration-200' +
        (isDropdownOpen() ? ' rotate-180' : '')
      "
      stroke="var(--color-neutral-500)" />
  </label>

  <!-- Date Range Dropdown -->
  @if (isDropdownOpen()) {
    <!-- Portalled with Tippy so the calendar stays inside the viewport. It opens beside the
         field: the calendar is taller than the space above or below a mid-screen field, and a
         side placement lets Tippy slide it vertically until it fits. -->
    <div
      data-date-range-anchor
      libTippyTooltip
      [contentTemplate]="dateRangePanel"
      placement="left-start"
      trigger="manual"
      [showOnInit]="true"
      interactive
      [referenceElement]="dateRangeTrigger"
      [toolTipClass]="'bg-white rounded-md shadow-lg w-[44rem] max-w-[calc(100vw-1rem)]'"
      [offset]="[0, 8]"
      class="absolute inset-0 pointer-events-none"
      aria-hidden="true"></div>
  }
</div>

<ng-template #dateRangePanel>
  <div
    data-date-range-panel
    class="overflow-visible"
    [formGroup]="dateRangeForm"
    libClickOutSide
    (clickOutside)="closeDropdown()">
    <div class="p-xl flex flex-col gap-xl overflow-visible">
      <div
        class="grid grid-cols-2 gap-lg relative overflow-visible [&_.date-picker]:relative [&_.date-picker]:mt-[0.85714285rem] [&_.days-of-week_div]:h-5xl [&_.days-of-week_div]:flex [&_.days-of-week_div]:items-center [&_.days-of-week_div]:justify-center [&_.days-of-week_div]:text-sm [&_.dates_.day]:h-5xl [&_.dates_.day]:flex [&_.dates_.day]:items-center [&_.dates_.day]:justify-center [&_.dates_.day]:text-sm">
        <div class="flex flex-col gap-sm relative z-10 overflow-visible">
          <label class="text-base font-medium text-neutral-700">{{
            'date_range_from_label' | transloco
          }}</label>
          <div class="relative overflow-visible">
            <lib-date-picker
              #startDatePicker
              [id]="startDateId()"
              [name]="startDateName()"
              [lang]="'current_lang' | transloco"
              [placeholder]="startDatePlaceholder() | transloco"
              [inputFormControlName]="startDateControlName()"
              [label]="''"
              [hasRange]="true" />
          </div>
        </div>

        <!-- To Date Picker -->
        <div
          class="flex flex-col gap-sm relative z-10 overflow-visible text-base">
          <label class="text-base font-medium text-neutral-700">{{
            'date_range_to_label' | transloco
          }}</label>
          <div class="relative overflow-visible">
            <lib-date-picker
              #endDatePicker
              [id]="endDateId()"
              [name]="endDateName()"
              [lang]="'current_lang' | transloco"
              [placeholder]="endDatePlaceholder() | transloco"
              [inputFormControlName]="endDateControlName()"
              [label]="''"
              [disabled]="isEndDateDisabled()"
              [minDate]="getMinDateForEndDate()"
              [dimmed]="isEndDateDisabled()"
              [hasRange]="true" />
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex items-center justify-end gap-md pt-lg">
        <button
          type="button"
          (click)="onCancel()"
          class="px-lg py-sm text-base font-medium text-neutral-700 bg-white border border-neutral-300 rounded-md hover:bg-neutral-50 transition-colors">
          {{ 'date_range_cancel' | transloco }}
        </button>
        <button
          type="button"
          (click)="onApply()"
          [disabled]="!canApply()"
          [class]="
            canApply()
              ? 'px-lg py-sm text-base font-medium text-white bg-primary-500 rounded-md transition-colors cursor-pointer'
              : 'px-lg py-sm text-base font-medium text-white bg-primary-300 rounded-md transition-colors cursor-not-allowed opacity-60'
          ">
          {{ 'date_range_apply' | transloco }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
